import styled from 'styled-components'

export const ArtistSearchCardContainer = styled.div`
  padding: 16px 24px;
  border-radius: 5px;
  background-color: transparent;
  max-width: 214px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutralW20};

    img {
      opacity: 0.8;
    }
  }
`

export const ImageContainer = styled.div`
  position: relative;
  width: 160px;
  height: 160px;
  margin-bottom: 8px;
`

export const ArtistSearchCardImage = styled.img`
  border-radius: 50%; /* Circular for artists */
  object-fit: cover;
  width: 100%;
  height: 100%;
  transition: opacity 0.2s ease;
`

export const TextContainer = styled.div`
  width: 160px;
  text-align: center;
`
